// extracted by mini-css-extract-plugin
module.exports = {"Box":"Box_Box__-xlV2"};